import { CanActivate, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ACCESS_TOKEN_KEY } from '../auth.constants';
import { AuthService } from '../services/auth.service';
import { EnvironmentService } from '@app/environments/services/environment.service';
import { IOktaToken } from '../interfaces';
import { WINDOW } from '@app/lib/services/window.service';

@Injectable()
export class APICGuard implements CanActivate {

  constructor(
    @Inject(WINDOW)
    private readonly window: Window,

    private readonly authService: AuthService,
    private readonly environmentService: EnvironmentService,
    private readonly router: Router
  ) {}

  canActivate(): boolean | Observable<boolean> {
    if (this.environmentService.environment.apicEnabled) {
      const oktaToken: IOktaToken = JSON.parse(this.window.localStorage.getItem(ACCESS_TOKEN_KEY));
      const accessToken = oktaToken?.accessToken.accessToken;

      if (accessToken) {
        return this.authService.convertOAuthToCookie(accessToken)
                                .pipe(
                                  map(() => true),
                                  catchError(() => {
                                    this.router.navigateByUrl('/unavailable');

                                    return of(false);
                                  })
                                );
      }
      else {
        return false;
      }
    }
    else {
      return true;
    }
  }
}
